/* eslint-env browser */
require('./scripts');
require('../activity-streams');
require('../fullcalendar');
